/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
  Alert,
  Button,
  Form,
  ButtonGroup,
  InputGroup,
  Card,
  Container,
  Dropdown,
  Modal,
  Spinner,
} from "@themesberg/react-bootstrap";
import { useState } from "react";
import { useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { apiURL, deleteApi, fetchApi, postApi } from "../../../redux/api";
import CustomTable from "../../../components/CustomTable";
import { toast } from 'react-hot-toast';
import SearchInput from "../../../components/SearchInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBackward,
  faCaretDown,
  faSearch,
  faEdit,
  faEye,
  faListUl,
  faMarker,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../routes";
import { formatNumber } from "../../../redux/utils";
import { SearchContext } from "../../HomePage";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import moment from "moment-timezone";
import { useResponsive } from "../../../hooks/useResponsive";
import ResponsiveContainer from "../../../components/ResponsiveContainer";
import MobileDataCard from "../../../components/MobileDataCard";
import ResponsiveButton from "../../../components/ResponsiveButton";

function MDARelease({ match, type = null }) {
  const { isMobile } = useResponsive();
  const user = useSelector((state) => state.auth.user);
  const history = useNavigate();
  const location = useLocation();
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  const [filterText, setFilterText] = useState("");
  const [budgetUtilization, setBudgetUtilization] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(moment().subtract(1, 'month').format('YYYY-MM-DD'));
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));

  const getMDAReleasesCollection = useCallback(() => {
    setLoading(true);
    postApi(`post_approval_collection`, {
      form: { 
        query_type: "by_cc", 
        cc: user?.mda_name,
        mda_code: user?.mda_code || "" 
      },
    })
      .then((data) => {
        console.log("MDA Releases data", data);
        if (data.result) {
          const arr = [];
          data.result.forEach((item) => {
            arr.push({ ...item, isOpen: false });
          });
          setBudgetUtilization(data.result);
        }
      })
      .catch((err) => {
        toast.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [user.mda_name]);

  useEffect(() => {
    getMDAReleasesCollection();
  }, [getMDAReleasesCollection]);

  const handleFilter = () => {
    const filteredList = budgetUtilization.filter((item) => {
      const dateFromCondition = dateFrom ? new Date(item.collection_date) >= new Date(dateFrom) : true;
      const dateToCondition = dateTo ? new Date(item.collection_date) <= new Date(dateTo) : true;
      return dateFromCondition && dateToCondition;
    });
    return filteredList;
  };

  useEffect(() => {
    handleFilter();
  }, [dateFrom, dateTo]);

  const filteredList = handleFilter();

  let list = [];
  filteredList.forEach((item) => {
    if (
      item.approval_no.indexOf(filterText) === -1 &&
      item.approval_no.toString().indexOf(filterText.toLowerCase()) === -1
    )
      return;
    else list.push(item);
  });

  const fields = [
    {
      title: "Action",
      custom: true,
      component: (item, index) => (
        <div>
          <Button onClick={() => {
            const url = `${Routes.approval.editApprovalRoute}?approval_no=${encodeURIComponent(item.full_approval_no)}&from=mda-releases`;
            history(url);
          }}>View</Button>
        </div>
      ),
    },
    {
      title: "Approval Date",
      value: "approval_date",
    },
    {
      title: "Approval No",
      value: "full_approval_no",
    },
    {
      title: "Approval Type",
      value: "approval_type",
    },
    {
      title: "Narration",
      value: "narration",
    },
    {
      title: "Status",
      value: "approval_status",
    },
    {
      title: "Amount",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
    },
  ];

  const getRowStyle = (row) => {
    if (row?.approval_status?.includes("Return")) {
      return { backgroundColor: "orange" };
    } else {
      return {}
    }
  };

  const finalList = [];
  list.forEach((item) => {
    if (item.approval_no.indexOf(searchTerm.toLowerCase()) === -1)
      return;
    finalList.push(item);
  });

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, [setSearchTerm]);

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>
            MDA Releases
          </h4>
          <p className="text-muted">Releases where your MDA is copied (CC)</p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm">
              Share
            </Button>
            <Button variant="outline-primary" size="sm">
              Export
            </Button>
          </ButtonGroup>
        </div>
      </div>

      <Row>
        <Col md={6} style={{
          marginTop: 28
        }}>
          <SearchInput
            placeholder="Search For MDA Releases"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Row style={{
            marginBottom: 10
          }}>
            <Col md={6}>
              <Form.Group id="date_from">
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group id="date_to">
                <Form.Label>Date to</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className={isMobile ? "" : "table-container"} style={{ height: isMobile ? "auto" : "80vh", overflow: isMobile ? "visible" : "scroll" }}>
              {isMobile ? (
                <div className="mobile-cards-container">
                  {finalList.map((item, index) => (
                    <MobileDataCard
                      key={index}
                      title={`Approval ${item.full_approval_no}`}
                      data={item}
                      primaryField={{
                        label: "Amount",
                        value: item.amount,
                        type: "currency"
                      }}
                      secondaryFields={[
                        {
                          label: "Approval Date",
                          value: item.approval_date,
                          type: "date"
                        },
                        {
                          label: "Type",
                          value: item.approval_type
                        },
                        {
                          label: "Narration",
                          value: item.narration
                        }
                      ]}
                      status={item.approval_status}
                      actions={[
                        {
                          type: "view",
                          label: "View PDF",
                          icon: faEye,
                          variant: "primary"
                        }
                      ]}
                      onActionClick={(actionType, data) => {
                        if (actionType === "view") {
                          const url = `${Routes.approval.editApprovalRoute}?approval_no=${encodeURIComponent(data.full_approval_no)}&from=mda-releases`;
                          history(url);
                        }
                      }}
                    />
                  ))}
                </div>
              ) : (
                <CustomTable
                  fields={fields}
                  data={finalList}
                  getRowStyle={(data) => getRowStyle(data)}
                />
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default MDARelease;